import { createGlobalStyle } from 'styled-components'
import { Box as BoxBase, styled } from '@mui/material'

export const GlobalStyle = createGlobalStyle`
  .highcharts-credits, 
  .highcharts-xaxis-labels text:first-of-type,
  .highcharts-xaxis-labels text:last-of-type {
    opacity: 1;
  }
`

export const Root = styled('div')`
  width: 100%;
`

export const Box = styled(BoxBase)`
  padding-left: 16px;
`

export const Exportable = styled('div')``
